import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Load Google Analytics script
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=G-KF9EEHBM3S";
    document.head.appendChild(script);

    // Configure Google Analytics
    const script2 = document.createElement("script");
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-KF9EEHBM3S', { page_path: window.location.pathname });
    `;
    document.head.appendChild(script2);
  }, [location]);

  return null;
};

export default GoogleAnalytics;
